import React, { useEffect, useMemo, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { icons } from "../../assets/icons";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import CustomTable from "../../components/CustomTable";
import { usersColumnsCreateGroup } from "../../components/Columns/Users";
import { rolesColumnsForGroupCreate } from "../../components/Columns/Roles";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";

const CreateGroups = () => {
  const { data: users = [], apiCall: getUsers } = useApi();
  const { data: roles = [], apiCall: getRoles } = useApi();
  const [searchParams] = useSearchParams();
  const paramsData = useLocation();
  const isUpdateGroupActive = paramsData?.state?.id ? true : false;
  const { apiCall: createGroup } = useApi();
  const { apiCall: updateGroup } = useApi();
  const [userIds, setUserIds] = useState(paramsData?.state?.groupUsers ? Object.keys(paramsData?.state?.groupUsers)?.map(i => Number(i)) :
    JSON.parse(searchParams.get("userIds") || "[]")
  );
  const [roleIds, setRoleIds] = useState(paramsData?.state?.groupRoles ? Object.keys(paramsData?.state?.groupRoles)?.map(i => Number(i)) :
    JSON.parse(searchParams.get("roleIds") || "[]")
  );
  const [groupName, setGroupName] = useState(paramsData?.state?.name || searchParams.get("groupName"));
  const navigate = useNavigate();
  useEffect(() => {
    getUsers({
      url: apiUrls.sso.getUsers,
      method: "get",
    });
  }, []);

  useEffect(() => {
    getRoles({
      url: apiUrls.sso.getRoles,
      method: "get",
    });
  }, []);

  const selectPositionFun = (rows, user) => { // for select initial position using index
    let arr = user;
    let data = rows.map((i, ind) => {
      if(arr.includes(i.id)){
        return ind;
      }
    })
    return data || [];
  }

  const onClickAddRole = () => {
    navigate(
      {
        pathname: window.location.pathname,
        search: createSearchParams({
          groupName,
          userIds: JSON.stringify(userIds),
          roleIds: JSON.stringify(roleIds),
        }).toString(),
      },
      { replace: true }
    );
    navigate("/roles/create");
  };

  const onClickUpdate = () => {
    if (!groupName) {
      toast.error("Group name is required");
      return;
    }
    updateGroup({
      url: apiUrls.sso.updateGroup,
      method: "put",
      dataToSend: {id: paramsData?.state.id, name: groupName, users: userIds, roles: roleIds },
      onSuccess: () => {
        toast.success("Group Update successfully");
        navigate(-1);
        // navigate("/groups")
        // window.location.reload()
      },
    });
  }

  const onClickAddUser = () => {
    navigate(
      {
        pathname: window.location.pathname,
        search: createSearchParams({
          groupName,
          userIds: JSON.stringify(userIds),
          roleIds: JSON.stringify(roleIds),
        }).toString(),
      },
      { replace: true }
    );
    navigate("/users/create");
  };

  const onClickBack = () => {
    navigate(-1);
  };

  const onClickSave = () => {
    if (!groupName) {
      toast.error("Group name is required");
      return;
    }
    createGroup({
      url: apiUrls.sso.createGroup,
      method: "post",
      dataToSend: {name: groupName, users: userIds, roles: roleIds },
      onSuccess: () => {
        toast.success("Group added successfully");
        navigate(-1);
        // navigate("/groups")
        // window.location.reload()
      },
    });
  };

  const memoUserColumns = useMemo(() => usersColumnsCreateGroup(), []);
  const memoRoleColumns = useMemo(() => rolesColumnsForGroupCreate, []);

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Groups > Create Group"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          return (
            <div className="flex items-center gap-x-6">
              <CustomButton
                title="Back"
                wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
                textClassName="text-[var(--blackColor)] pl-2"
                onClick={onClickBack}
                icon={icons.backIcon}
              />
              <CustomButton
                title={isUpdateGroupActive ? "Update" : "Save"}
                wrapperClassName="!px-5"
                textClassName="pl-2"
                onClick={isUpdateGroupActive ? onClickUpdate : onClickSave}
              />
            </div>
          );
        }}
      />

      <div className="px-6 py-8 bg-[#fff] mt-10 rounded-[1rem]">
        <div className="font-size-medium font-family-medium">Group Name</div>
        <div className="font-size-small mb-5 text-[var(--darkGray2)]">
          {/* Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. */}
        </div>
        <InputWithIcon
          wrapperClassName="w-[35%]"
          containerClassName="!min-h-[4rem] !bg-transparent border-[1px] border-[var(--borderGray1)]"
          placeholder="Enter the group name here"
          onChange={(e) => {
            setGroupName(e);
          }}
          value={groupName !== null ? groupName : ""}
        />
      </div>
      <div className="px-6 py-8 bg-[#fff] mt-6 rounded-[1rem]">
        <div className="flex justify-between">
          <div>
            <div className="font-size-medium font-family-medium">
              Add User to the Group -{" "}
              <i className="font-family-regular text-[#898989]">Optional</i>
            </div>
            <div className="font-size-small mb-5 text-[var(--darkGray2)]">
              {/* Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. */}
            </div>
          </div>
          <CustomButton
            title="Add New User"
            wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
            textClassName="text-[var(--blackColor)] pl-2"
            onClick={onClickAddUser}
            icon={icons.plusBlackIcon}
          />
        </div>
        {/* <InputWithIcon
          placeholder="Search Users"
          containerClassName="search-input-wrapper"
          wrapperClassName="!h-[4rem]"
          inputClassName="font-size-small"
          rightIcon={icons.searchIcon}
          //   onChange={(e) => setSearchText(e)}
          //   value={searchText}
        /> */}
        <CustomTable
          data={users}
          columns={memoUserColumns}
          centerAlignedColumns={["groups"]}
          showCheckboxes
          onCheckboxSelect={(selectedCheckboxes) => {
            if (users.length) {
              setUserIds(selectedCheckboxes?.map((item) => item?.original?.id));
            }
          }}
          initialCheckboxesData={selectPositionFun(users, userIds)}

          // selectedCheckboxes={userIds}
          isGlobalSearchEnable={true}
        />
      </div>
      <div className="px-6 py-8 bg-[#fff] mt-6 rounded-[1rem]">
        <div className="flex justify-between">
          <div>
            <div className="font-size-medium font-family-medium">
              Add Role to the Group -{" "}
              <i className="font-family-regular text-[#898989]">Optional</i>
            </div>
            <div className="font-size-small mb-5 text-[var(--darkGray2)]">
              {/* Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. */}
            </div>
          </div>
          <CustomButton
            title="Add New Role"
            wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
            textClassName="text-[var(--blackColor)] pl-2"
            onClick={onClickAddRole}
            icon={icons.plusBlackIcon}
          />
        </div>

        {/* <InputWithIcon
          placeholder="Search Roles"
          containerClassName="search-input-wrapper"
          wrapperClassName="!h-[4rem]"
          inputClassName="font-size-small"
          rightIcon={icons.searchIcon}
          //   onChange={(e) => setSearchText(e)}
          //   value={searchText}
        /> */}
        <CustomTable
          data={roles}
          columns={memoRoleColumns}
          showCheckboxes
          onCheckboxSelect={(selectedCheckboxes) => {
            if (roles.length) {
              setRoleIds(selectedCheckboxes?.map((item) => item?.original?.id));
            }
          }}
          initialCheckboxesData={selectPositionFun(roles, roleIds)}

          // selectedCheckboxes={roleIds}
          isGlobalSearchEnable={true}
        />
      </div>
      <div className="flex items-center justify-between mt-10">
        <CustomButton
          title="Back"
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
          textClassName="text-[var(--blackColor)] pl-2"
          onClick={onClickBack}
          icon={icons.backIcon}
        />
        <CustomButton
          title={isUpdateGroupActive ? "Update" : "Save"}
          wrapperClassName="!px-5"
          textClassName="pl-2"
          onClick={isUpdateGroupActive ? onClickUpdate : onClickSave}
        />
      </div>
    </div>
  );
};

export default CreateGroups;
